import * as React from "react";
const SvgDone = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" }));
export default SvgDone;
